export default function Footer() {
  return (
    <footer className="bg-lavender-light py-8">
      <div className="container mx-auto px-4 text-center">
        <p className="text-lavender-dark font-serif text-xl mb-2">
          With love and gratitude
        </p>
      </div>
    </footer>
  );
}
